import { render } from "./DefTrackingClick.vue?vue&type=template&id=1d85f0ab"
import script from "./DefTrackingClick.vue?vue&type=script&lang=js"
export * from "./DefTrackingClick.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__